 <div class="row" style="padding-top: 5px;">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair">
       <div class="m-portlet__head">
         <div class="m-portlet__head-caption">
           <div class="m-portlet__head-title">
             <h3 *ngIf="rep?.RepInformation" class="m-portlet__head-text"
                 style="font-size: 20pt;font-weight: normal;">
               {{differentLoggedIn ? ('REP' | dictionary) : (('WELCOME' | dictionary) + ', ')}} {{rep?.RepInformation.RepName}}
             </h3>
           </div>
         </div>
         <span class="m-portlet__head-caption" *ngIf="InboxCount > 0">
                     <h5 style="color: #fff; text-decoration: underline;cursor: pointer; font-size: 14px;"
                         (click)="navigateToUnReadMsg()">
                         ({{InboxCount}}) {{'NEW_MESSAGES' | dictionary}}
                     </h5>
                 </span>
       </div>
       <app-announcement-block [announcements]="Announcements"></app-announcement-block>
     </div>
   </div>
 </div>

 <app-portfolio-block [userInfo]="rep"
                      [user]="rep?.RepInformation" [differentLoggedIn]="differentLoggedIn"
                      [label]="'REP' | dictionary"></app-portfolio-block>

 <div class="row">

   <app-documents-block class="col-lg-6" [label]="'REP' | dictionary" [statements]="statements"
                        [communications]="communications" [taxes]="taxes"
                        [differentLoggedIn]="differentLoggedIn"></app-documents-block>

   <div class="col-lg-6">
     <app-forms-block [forms]="forms" [label]="'REP' | dictionary"
                      [differentLoggedIn]="differentLoggedIn"></app-forms-block>
     <app-contacts [contacts]="contacts"></app-contacts>
   </div>

 </div>

 <div class="row">

 </div>

 <app-pop-up-dialog [Message]="alertmessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>
